import HTTP from "@/_helpers/http";
import { DEPOSITMETHODS__API } from "@/_helpers/urls";
import { DEPOSITMETHODS__MUTATIONS } from "../mutation-types";
import { DEPOSITMETHODS__ACTIONS } from "../action-types";
import toast from "@/services/Notification";
import router from "@/router";

// State
const state = {
    methods: [],
    accounts: [],
    banks: [],
    inrrate:[],
    needSlip: null,
    paymentSystem: null
};

//Getters
const getters = {};

//Mutations
const mutations = {
    [DEPOSITMETHODS__MUTATIONS.DEPOSITMETHODS](state, data) {
        state.methods = data;
    },
    [DEPOSITMETHODS__MUTATIONS.BROKERSBANK](state, data) {
        state.banks = data;
    },
    [DEPOSITMETHODS__MUTATIONS.DEPOSITACCOUNTS](state, data) {
        state.accounts = data;
    },
    [DEPOSITMETHODS__MUTATIONS.NEEDSLIP](state, data) {
        state.needSlip = data;
    },
    [DEPOSITMETHODS__MUTATIONS.GETPAYMENTSYSTEM](state, data) {
        state.paymentSystem = data;
    },
    [DEPOSITMETHODS__MUTATIONS.INRRATE](state, data) {
        state.inrrate = data;
    },
    [DEPOSITMETHODS__MUTATIONS.CREATECRYPTODEPOSITOVIPAYQR](state, payload) {
        state.createPaymentData = payload;
    },
    [DEPOSITMETHODS__MUTATIONS.CHECKCRYPTODEPOSITOVIPAY](state, payload) {
        state.checkPaymentData = payload;
    },
};

// Actions
const actions = {
    async [DEPOSITMETHODS__ACTIONS.CREATECRYPTODEPOSITOVIPAYQR](
        { commit },
        payload
    ) {
        try {
        const url = `${DEPOSITMETHODS__API.CREATECRYPTODEPOSITOVIPAYQR}`;
        const data = await HTTP({
            trackProgress: true,
            loadingText: "Processing...",
        }).post(url, payload);
        return data.data;
        } catch (error) {
        console.error(
            "Error:",
            error.response?.data || error.message
        );
        toast.error(
            error.response?.data?.message || "OvyPay payment creation failed."
        );
        throw error;
        }
    },

    async [DEPOSITMETHODS__ACTIONS.CHECKCRYPTODEPOSITOVIPAY](
        { commit },
        paymentId
    ) {
        try {
        const url = `${DEPOSITMETHODS__API.CHECKCRYPTODEPOSITOVIPAY}?paymentId=${paymentId}`;
        const data = await HTTP({
            trackProgress: true,
            loadingText: "Processing...",
        }).get(url);

        return data.data;
        } catch (error) {
        console.error(
            "CHECKCRYPTODEPOSITOVIPAY error:",
            error.response?.data || error.message
        );
        toast.error(
            error.response?.data?.message || "Error checking OvyPay payment status."
        );
        throw error;
        }
    },
    async [DEPOSITMETHODS__ACTIONS.INRRATE]({ commit, state }) {
        try {
            const url = `${DEPOSITMETHODS__API.INRRATE}`;
            const response = await HTTP({
                trackProgress: true,
                loadingText: 'Processing...'
            }).get(url);
            commit(DEPOSITMETHODS__MUTATIONS.INRRATE, response.data);
        } catch (error) {
            console.log(error);
        }
    },
    async [DEPOSITMETHODS__ACTIONS.CREATEBANKDEPOSIT]({ commit, state }, data) {
        try {
            const url = `${DEPOSITMETHODS__API.CREATEBANKDEPOSIT}`;
            const response = await HTTP({
                trackProgress: true,
                loadingText: 'Processing...'
            }).post(url, data);
            if (response.status === 200) {
                toast.success(response.data.message || "Deposited Successfull")
                router.push("/wallet")
            }
        } catch (error) {
            console.log(error);
            toast.error(error.response.data.message || "Failed to deposit")
        }
    },
    async [DEPOSITMETHODS__ACTIONS.PAYMENTLOG]({ commit, state }, data) {
        try {
        const url = `${DEPOSITMETHODS__API.PAYMENTLOG}`;
        await HTTP({
            trackProgress: true,
            loadingText: "Processing...",
        }).post(url, data);
        } catch (error) {
        toast.error(error.response.data.message || "Failed to create log");
        }
    },

    async [DEPOSITMETHODS__ACTIONS.PAYMENTNOTIFICATION]({ commit, state }, data) {
        try {
        const url = `${DEPOSITMETHODS__API.PAYMENTNOTIFICATION}`;
        await HTTP({
            trackProgress: true,
            loadingText: "Processing...",
        }).post(url, data);
        } catch (error) {
        toast.error(
            error.response.data.message || "Failed to create notification"
        );
        }
    },
    async [DEPOSITMETHODS__ACTIONS.CREATECASHDEPOSIT]({ commit, state }, data) {
        try {
            const url = `${DEPOSITMETHODS__API.CREATECASHDEPOSIT}`;
            const response = await HTTP({
                trackProgress: true,
                loadingText: 'Processing...'
            }).post(url, data);
            if (response.status === 200) {
                toast.success(response.data.message || "Deposited Successfull")
                router.push("/wallet")
            }
        } catch (error) {
            console.log(error);
            toast.error(error.response.data.message || "Failed to deposit")
        }
    },
    async [DEPOSITMETHODS__ACTIONS.CREATECRYPTODEPOSIT]({ commit, state }, data) {
        try {
            const url = `${DEPOSITMETHODS__API.CREATECRYPTODEPOSIT}`;
            const response = await HTTP({
                trackProgress: true,
                loadingText: 'Processing...'
            }).post(url, data);
            if (response.status === 200) {
                toast.success(response.data.message || "Deposited Successfull")
                router.push("/wallet")
            }
        } catch (error) {
            console.log(error);
            toast.error(error.response.data.message || "Failed to deposit")
        }
    },
    async [DEPOSITMETHODS__ACTIONS.CREATEGPAYDEPOSIT]({ commit, state }, data) {
        try {
            const url = `${DEPOSITMETHODS__API.CREATEGPAYDEPOSIT}`;
            const response = await HTTP({
                trackProgress: true,
                loadingText: 'Processing...'
            }).post(url, data);
            if (response.status === 200) {
                toast.success(response.data.message || "Deposited Successfully")
                router.push("/wallet")
            }
        } catch (error) {
            console.log(error);
            toast.error(error.response.data.message || "Failed to deposit")
        }
    },
    async [DEPOSITMETHODS__ACTIONS.CREATECARDDEPOSIT]({ commit, state }, data) {
        try {
            const url = `${DEPOSITMETHODS__API.CREATECARDDEPOSIT}`;
            const response = await HTTP({
                trackProgress: true,
                loadingText: 'Processing...'
            }).post(url, data);
            if (response.status === 200) {
                toast.success(response.data.message || "Deposited Successfully")
                router.push("/wallet")
            }
        } catch (error) {
            console.log(error);
            toast.error(error.response.data.message || "Failed to deposit")
        }
    },
    async [DEPOSITMETHODS__ACTIONS.DEPOSITMETHODS]({ commit, state }) {
        try {
            const url = `${DEPOSITMETHODS__API.DEPOSITMETHODS}`;
            const response = await HTTP({
                trackProgress: true,
                loadingText: 'Processing...'
            }).get(url);
            commit(DEPOSITMETHODS__MUTATIONS.DEPOSITMETHODS, response.data);
        } catch (error) {
            console.log(error);
        }
    },
    async [DEPOSITMETHODS__ACTIONS.DEPOSITACCOUNTS]({ commit, state }) {
        try {
            const url = `${DEPOSITMETHODS__API.DEPOSITACCOUNTS}`;
            const response = await HTTP({
                trackProgress: true,
                loadingText: 'Processing...'
            }).get(url);
            commit(DEPOSITMETHODS__MUTATIONS.DEPOSITACCOUNTS, response.data);
        } catch (error) {
            console.log(error);
        }
    },
    async [DEPOSITMETHODS__ACTIONS.BROKERSBANK]({ commit, state }) {
        try {
            const url = `${DEPOSITMETHODS__API.BROKERSBANK}`;
            const response = await HTTP({
                trackProgress: true,
                loadingText: 'Processing...'
            }).get(url);
            commit(DEPOSITMETHODS__MUTATIONS.BROKERSBANK, response.data);
        } catch (error) {
            console.log(error);
        }
    },
    async [DEPOSITMETHODS__ACTIONS.GETPAYMENTSYSTEM]({ commit, state }, payment_id) {
        try {
            const url = `${DEPOSITMETHODS__API.GETPAYMENTSYSTEM}`;
            const response = await HTTP().post(url,payment_id);
            commit(DEPOSITMETHODS__MUTATIONS.GETPAYMENTSYSTEM, response.data);
        } catch (error) {
            console.log(error);
        }
    },
    async [DEPOSITMETHODS__ACTIONS.NEEDSLIP]({ commit, state }) {
        try {
            const url = `${DEPOSITMETHODS__API.NEEDSLIP}`;
            const response = await HTTP().get(url);
            commit(DEPOSITMETHODS__MUTATIONS.NEEDSLIP, response.data);
        } catch (error) {
            console.log(error);
        }
    },
};

export default {
    namespaced: true,
    strict: process.env.NODE_ENV !== "production",
    state,
    getters,
    mutations,
    actions,
};
